// extracted by mini-css-extract-plugin
export default {"buttonSecondary":"ButtonSecondary_buttonSecondary__Dfcy6"};